import { render, staticRenderFns } from "./UserSubscriptionsDataTable.vue?vue&type=template&id=b8542cb8"
import script from "./UserSubscriptionsDataTable.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports